import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { ref: "widget" }
const _hoisted_2 = ["data-fit"]
const _hoisted_3 = { class: "BestFitLogo" }
const _hoisted_4 = {
  key: 0,
  class: "PlusIcon lnr-plus-inverted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.incentiveClicked && _ctx.incentiveClicked(...args))),
      class: _normalizeClass([_ctx.blueBackground ? 'BlueBackground' : '', "ButtonIconWidget js-Widget"]),
      "data-fit": _ctx.bestFitScore
    }, [
      (_ctx.hasEmptyText || (_ctx.isFullProfile && _ctx.userLoggedIn))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([_ctx.greyText ? 'GreyText' : '', "FitText"])
          }, _toDisplayString(_ctx.fitText), 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("i", {
          class: _normalizeClass([_ctx.isFullProfile && _ctx.userLoggedIn ? 'Blue' : '', "BestFitIcon lnr-bestfit-logo"])
        }, null, 2 /* CLASS */),
        (!_ctx.isFullProfile || !_ctx.userLoggedIn)
          ? (_openBlock(), _createElementBlock("i", _hoisted_4))
          : _createCommentVNode("v-if", true)
      ])
    ], 10 /* CLASS, PROPS */, _hoisted_2)
  ], 512 /* NEED_PATCH */))
}